import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGlobalSnackbar } from "src/context/SnackbarContext";
import { updateCompanyNumberAction } from "../actions/update-company-number.actions";
import { COMPANY_NUMBERS_KEY } from "../query/company-numbers.queries";

type UpdateCompanyNumberPayload = {
    id: string;
    phone: string;
    name: string;
};

export const useCompanyNumberMutation = () => {
    const { showSnackbar } = useGlobalSnackbar();
    const queryClient = useQueryClient();

    const updateNumberMutation = useMutation({
        mutationFn: async ({ id, phone, name }: UpdateCompanyNumberPayload) => {
            return updateCompanyNumberAction(id, phone, name);
        },
        onSuccess: () => {
            showSnackbar("Company number updated successfully", "success");

            queryClient.invalidateQueries({
                queryKey: COMPANY_NUMBERS_KEY,
            });
        },
        onError: () => {
            showSnackbar("Failed to update company number", "error");
        },
    });

    const deleteCompanyNumber = (id: string) => {
        console.log("delete company number:", id);
    };

    return {
        updateNumber: updateNumberMutation.mutateAsync,
        isUpdatingNumber: updateNumberMutation.isPending,
        deleteNumber: deleteCompanyNumber,
    };
};